<main>
    <app-header></app-header>
    <router-outlet></router-outlet>
</main>
